import type { Column, Filter } from '@/components/table/base'
import type { LicensePropertyData } from '@/stores/licenses'

export const LICENSES_TABLE_COLUMNS: Column<LicensePropertyData>[] = [
  {
    type: 'text',
    id: 'property',
    label: 'Property Name',
    sortAttribute: 'property'
  },
  {
    type: 'number',
    id: 'operatorCount',
    label: 'Number of Active Operators',
    sortAttribute: 'operatorCount'
  }
]

export const LICENSES_TABLE_FILTERS: Filter<LicensePropertyData>[] = [
  {
    type: 'freeTextSearch',
    paramName: 'ft',
    placeholder: 'Search Property Name',
    filterOptions: (row, search) => {
      if (!search) return true

      const lowerCaseSearch = search.toLowerCase()
      const { property } = row

      return property.toLowerCase().includes(lowerCaseSearch)
    }
  }
]
